import React, { Component } from "react";
import EmailList from "./tierDetailsEmailListItem";
import { confirm } from "../confirmation";
import { CirclePicker } from "react-color";
import { toast } from "react-toastify";
import History from "../../utils/history";
import TierDropdown from "../parts/tierDropdown";
import HelpHint from "../parts/helpHint";
import Moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faExclamationTriangle,
} from "@fortawesome/free-solid-svg-icons";
import { TiersApi } from "../../services/api/tiers";
import { EmailsApi } from "../../services/api/emails";
import {
  Box,
  Typography,
  Button,
  Grid,
  TextField,
  Chip,
  Collapse,
  List,
  Paper,
  CircularProgress,
  Snackbar,
  Alert,
  Container,
  useTheme,
  useMediaQuery,
} from "@mui/material";

Moment.locale("en");

class TierDetails extends Component {
  _isMounted = false;

  state = {
    message: "",
    showToast: false,
    ToastTitle: "",
    loading: false,
    user: this.props.user,
    init: true,
    relId: this.props.match.params.id || "0",
    color: "#EEEEEE",
    selectedColor: "#EEEEEE",
    editColor: false,
    emailList: [],
    emailListLoading: true,
    editNotes: false,
    oldNotes: "",
    disableNotes: false,
    editName: false,
    oldName: false,
    disableName: false,
    editColorButton: "Edit Color",
    isLoading: true,
    showParentTierChange: false,
    fontColor: "#333333",
  };

  componentDidMount() {
    this._isMounted = true;

    this.getTierDetailsEndpoint();
    this.getEmailListEndpoint();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getTierListEndpoint = async () => {
    console.log("getting tiers...");
    try {
      const response = await TiersApi.getTiers(this.props.token);
      
      if (response.success) {
        let list = response.data.map((item) => ({
          title: `Tier ${item.relId}`,
          relId: item.relId,
          tier: item.tierName,
          color: item.color,
          parentTier: item.parentTier,
        }));

        if (list.length === 0) {
          list.push({
            title: "No Tier",
            relId: 0,
            tier: "No Tier",
            color: "#FFFFFF",
          });
        }

        if (this._isMounted) {
          this.getInheritanceInit(list);
        }
      } else {
        console.log("there's a problem with this endpoint");
      }
    } catch (err) {
      console.log("Error getting tier list from endpoint", err);
    }
  };

  getInheritanceInit = (tiers) => {
    const tiersWithInheritance = tiers.map((tier) => {
      const inheritance = this.getChildTiers(tier.relId, tiers);
      return { ...tier, inheritance };
    });
    localStorage.setItem("tiers", JSON.stringify(tiersWithInheritance));
    // Also save with user-specific key
    const userId = this.props.user?.sub || 'unknown';
    localStorage.setItem(`tiers_${userId}`, JSON.stringify(tiersWithInheritance));
  };

  getChildTiers = (parentId, allTiers) => {
    const children = allTiers.filter(tier => tier.parentTier === parentId);
    let allChildren = [];
    
    children.forEach(child => {
      allChildren.push(child.nickname);
      // Recursively get grandchildren
      const grandChildren = this.getChildTiers(child.relId, allTiers);
      allChildren = allChildren.concat(grandChildren);
    });
    
    return allChildren;
  };

  getTierDetailsEndpoint = async () => {
    try {
      const response = await TiersApi.getTierDetails(this.props.token, this.state.relId);

      if (response.success) {
        if (!response.data.length) {
          History.push("/404");
        } else {
          const tierData = response.data[0];
          const color = tierData.color;
          let c = color.substring(1);
          let rgb = parseInt(c, 16);
          let r = (rgb >> 16) & 0xff;
          let g = (rgb >> 8) & 0xff;
          let b = (rgb >> 0) & 0xff;
          let luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;
          let fontColor = luma < 150 ? "#FFFFFF" : "#333333";

          this.setState({
            tierName: tierData.tierName,
            createdAt: tierData.createdAt,
            color: color,
            id: tierData.id,
            parentTier: parseInt(tierData.parentTier),
            notes: tierData.notes,
            selectedColor: color,
            isLoading: false,
            fontColor: fontColor,
          });
        }
      } else {
        console.log("failure on endpoint", response.status);
      }
    } catch (err) {
      console.log("error on add endpoint", err);
    }
  };

  setShow = (sta) => {
    this.setState({ showToast: sta });
  };

  deleteTierEndpoint = async () => {
    if (await confirm("Are you sure?")) {
      try {
        const response = await TiersApi.deleteTier(this.props.token, this.state.id, this.state.relId);

        if (response.success) {
          localStorage.removeItem("tiers");
          // Clear user-specific tiers cache as well
          const userId = this.props.user?.sub || 'unknown';
          localStorage.removeItem(`tiers_${userId}`);
          // Use React Router v6 navigate prop to redirect
          this.props.navigate("/tiers");
        } else {
          toast.warn(`Something went wrong with deleting the tier: Error: ${response.status || 'Unknown error'}`);
        }
      } catch (err) {
        toast.warn("Uh oh, something went wrong with deleting the tier: Syntax Error.");
      }
    }
  };

  getEmailListEndpoint = async () => {
    try {
      const response = await EmailsApi.getEmailDetails(this.props.token, this.props.match.params.id);

      if (response.success) {
        const emailList = response.data.map((item) => ({
          id: item.id,
          note: item.note,
          email: item.email,
        }));

        if (this._isMounted) {
          this.setState({
            emailList: emailList,
            count: emailList.length,
            init: false,
            emailListLoading: false,
          });
        }
      } else {
        toast.warn(`Something went wrong with getting tier details: Error: ${response.status || 'Unknown error'}`);
      }
    } catch (err) {
      toast.warn("Uh oh, something went wrong with getting tier details: Syntax Error.");
    }
  };

  startEditNotes = () => {
    this.setState({ oldNotes: this.state.notes, editNotes: true });
  };

  handleEditNotes = (ev) => {
    this.setState({ notes: ev.target.value });
  };

  handleEditColors = async () => {
    this.setState((prevState) => ({
      editColor: !prevState.editColor,
      editColorButton: prevState.editColor ? "Edit Color" : "Save Changes",
    }));

    if (this.state.editColor) {
      if (this.state.color !== this.state.selectedColor) {
        try {
          const response = await TiersApi.updateTier(this.props.token, {
            tierid: this.state.id,
            type: "color",
            data: this.state.selectedColor,
          });

          if (response.success) {
            this.setState({ color: this.state.selectedColor });
            this.getTierListEndpoint();
            toast.success("Color updated");
          } else {
            toast.warn(`Something went wrong with updating color: Error: ${response.status || 'Unknown error'}`);
          }
        } catch (error) {
          toast.warn("Uh oh, something went wrong with updating color: Syntax Error.");
        }
      }
    }
  };

  editNotesSubmit = async (ev) => {
    ev.preventDefault();
    this.setState({ disableNotes: true });

    try {
      const response = await TiersApi.updateTier(this.props.token, {
        tierid: this.state.id,
        type: "notes",
        data: this.state.notes || "no note",
      });

      if (response.success) {
        this.setState({ editNotes: false });
        toast.success("Notes updated");
        this.getTierListEndpoint();
      } else {
        toast.warn(`Something went wrong with updating notes: Error: ${response.status || 'Unknown error'}`);
      }
    } catch (error) {
      toast.warn("Something went wrong with updating notes: Syntax Error");
    } finally {
      this.setState({ disableNotes: false });
    }
  };

  toggleChangeParentTier = async (color, relId, name, tierId) => {
    // Prevent setting itself as parent
    if (relId === this.state.relId) {
      toast.warn("Cannot set a tier as its own parent.");
      this.handleParentChange(false);
      return;
    }
    this.setState({ parentTier: relId });

    try {
      const response = await TiersApi.updateTier(this.props.token, {
        tierid: this.state.id,
        type: "parentTier",
        data: relId,
      });

      if (response.success) {
        toast.success("Parent tier updated");
        this.getTierListEndpoint();
      } else {
        toast.warn(`Something went wrong with updating parent tier: Error: ${response.status || 'Unknown error'}`);
      }
    } catch (error) {
      toast.warn("Something went wrong with updating parent tier: Syntax Error");
    }

    this.handleParentChange(false);
  };

  startEditName = () => {
    this.setState({ oldName: this.state.tierName, editName: true });
  };

  handleEditName = (ev) => {
    this.setState({ tierName: ev.target.value });
  };

  handleChangeComplete = (color) => {
    if (this._isMounted) this.setState({ selectedColor: color.hex });
  };

  editNameSubmit = async (ev) => {
    ev.preventDefault();
    if (this.state.tierName === "") {
      this.setMessage("Can't have empty tier name!", "There's a problem", true);
      return;
    }
    this.setState({ disableName: true });

    try {
      const response = await TiersApi.updateTier(this.props.token, {
        tierid: this.state.id,
        type: "tierName",
        data: this.state.tierName,
      });

      if (response.success) {
        this.setState({ editName: false });
        this.getTierListEndpoint();
        toast.success("Tier name updated");
      } else {
        toast.warn(`Something went wrong with updating Tier name: Error: ${response.status || 'Unknown error'}`);
      }
    } catch (error) {
      toast.warn("Something went wrong with updating Tier name: Syntax Error");
    } finally {
      this.setState({ disableName: false });
    }
  };

  handleParentChange = (i) => {
    this.setState({ showParentTierChange: i });
  };

  setMessage = (msg, title = "", setshow = "") => {
    this.setState({ message: msg, ToastTitle: title, showToast: setshow !== "" });
  };

  render() {
    const {
      isLoading,
      emailListLoading,
      showToast,
      message,
      editName,
      tierName,
      disableName,
      color,
      fontColor,
      relId,
      createdAt,
      selectedColor,
      editColor,
      editColorButton,
      showParentTierChange,
      parentTier,
      editNotes,
      notes,
      disableNotes,
      emailList,
    } = this.state;

    if (isLoading || emailListLoading) {
      return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress size={60} />
          </Box>
        </Container>
      );
    }

    return (
      <React.Fragment>
        <HelpHint
          title="Tier details"
          hints={[
            "Edit the tier name, color, and notes",
            "View subscribers assigned to this tier",
            "Delete or archive unused tiers",
          ]}
        />

        <Snackbar
          open={showToast}
          autoHideDuration={6000}
          onClose={() => this.setShow(false)}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert onClose={() => this.setShow(false)} severity="info" sx={{ width: "100%" }}>
            {message}
          </Alert>
        </Snackbar>

        <TierDetailsContent 
          {...this.state}
          startEditName={this.startEditName}
          handleEditName={this.handleEditName}
          editNameSubmit={this.editNameSubmit}
          handleParentChange={this.handleParentChange}
          toggleChangeParentTier={this.toggleChangeParentTier}
          handleEditColors={this.handleEditColors}
          deleteTierEndpoint={this.deleteTierEndpoint}
          startEditNotes={this.startEditNotes}
          handleEditNotes={this.handleEditNotes}
          editNotesSubmit={this.editNotesSubmit}
          handleChangeComplete={this.handleChangeComplete}
          setShow={this.setShow}
          token={this.props.token}
        />
      </React.Fragment>
    );
  }
}

// Functional component to use Material-UI hooks
function TierDetailsContent({
  isLoading,
  emailListLoading,
  showToast,
  message,
  editName,
  tierName,
  disableName,
  color,
  fontColor,
  relId,
  createdAt,
  selectedColor,
  editColor,
  editColorButton,
  showParentTierChange,
  parentTier,
  editNotes,
  notes,
  disableNotes,
  emailList,
  startEditName,
  handleEditName,
  editNameSubmit,
  handleParentChange,
  toggleChangeParentTier,
  handleEditColors,
  deleteTierEndpoint,
  startEditNotes,
  handleEditNotes,
  editNotesSubmit,
  handleChangeComplete,
  setShow,
  token,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isLoading || emailListLoading) {
    return (
      <Container 
        maxWidth="lg" 
        sx={{ 
          py: 4,
          width: isMobile ? "95vw" : "100%"
        }}
      >
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
          <CircularProgress size={60} />
        </Box>
      </Container>
    );
  }

  return (
    <Container 
      maxWidth="lg" 
      sx={{ 
        py: { xs: 2, sm: 3, md: 4 },
        width: isMobile ? "95vw" : "100%"
      }}
    >
      <Paper sx={{ 
        p: { xs: 2, sm: 3, md: 4 }, 
        borderRadius: { xs: 1, sm: 2 },
        boxShadow: { xs: 1, sm: 2 }
      }}>
        <Grid container spacing={{ xs: 2, sm: 3 }} alignItems="center">
          <Grid item xs={12} lg={6}>
            {editName ? (
              <Box component="form" onSubmit={editNameSubmit}>
                <TextField
                  fullWidth
                  label="Tier Name"
                  variant="outlined"
                  defaultValue={tierName}
                  onChange={handleEditName}
                  disabled={disableName}
                  helperText="Press enter to save new Tier Name"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontSize: { xs: '0.9rem', sm: '1rem' }
                    }
                  }}
                />
              </Box>
            ) : (
              <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
                <Typography 
                  variant={isMobile ? "h6" : "h5"} 
                  component="h1" 
                  sx={{ 
                    fontSize: { xs: '1.25rem', sm: '1.5rem' },
                    fontWeight: 600,
                    wordBreak: 'break-word'
                  }}
                >
                  {tierName}
                </Typography>
                <Button 
                  size="small" 
                  onClick={startEditName} 
                  id="tour-1"
                  variant="outlined"
                >
                  Edit
                </Button>
              </Box>
            )}
            <Box 
              display="flex" 
              alignItems="center" 
              mt={{ xs: 1.5, sm: 2 }}
              flexWrap="wrap"
              gap={1}
            >
              <Chip
                label={`Tier ${relId}`}
                style={{ backgroundColor: color, color: fontColor }}
                size={isMobile ? "small" : "medium"}
              />
              <Typography 
                variant="body2" 
                sx={{ 
                  fontSize: { xs: '0.8rem', sm: '0.875rem' },
                  color: 'text.secondary'
                }}
              >
                <strong>Created:</strong> {Moment.unix(createdAt).format("LL")}
              </Typography>
            </Box>
          </Grid>
          
          <Grid item xs={12} lg={6}>
            <Box 
              display="flex" 
              flexDirection={{ xs: 'column', sm: 'row' }}
              justifyContent={{ sm: 'flex-end' }}
              gap={{ xs: 1, sm: 1.5 }}
              alignItems={{ xs: 'stretch', sm: 'center' }}
            >
              {showParentTierChange ? (
                <TierDropdown
                  token={token}
                  action={toggleChangeParentTier}
                  defaultValue={parentTier}
                  size="sm"
                  excludeId={relId}
                />
              ) : (
                <Button 
                  variant="outlined" 
                  size={isMobile ? "medium" : "small"}
                  onClick={() => handleParentChange(true)}
                  sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
                >
                  Change Parent Tier
                </Button>
              )}
              
              <Button
                variant="contained"
                size={isMobile ? "medium" : "small"}
                style={{ backgroundColor: selectedColor, borderColor: selectedColor }}
                onClick={handleEditColors}
                id="tour-2"
                startIcon={<FontAwesomeIcon icon={faCog} />}
                sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
              >
                {editColorButton}
              </Button>
              
              <Button
                variant="outlined"
                color="error"
                size={isMobile ? "medium" : "small"}
                onClick={deleteTierEndpoint}
                id="tour-3"
                startIcon={<FontAwesomeIcon icon={faExclamationTriangle} />}
                sx={{ fontSize: { xs: '0.8rem', sm: '0.875rem' } }}
              >
                Delete
              </Button>
            </Box>
          </Grid>
        </Grid>

        <Box mt={{ xs: 2, sm: 3 }}>
          {editNotes ? (
            <Box component="form" onSubmit={editNotesSubmit}>
              <TextField
                fullWidth
                label="Notes"
                variant="outlined"
                defaultValue={notes}
                onChange={handleEditNotes}
                disabled={disableNotes}
                helperText="Press enter to save your notes"
                multiline
                rows={isMobile ? 2 : 3}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: { xs: '0.9rem', sm: '1rem' }
                  }
                }}
              />
            </Box>
          ) : (
            <Box display="flex" alignItems="flex-start" gap={1} flexWrap="wrap">
              <Button 
                size="small" 
                onClick={startEditNotes} 
                id="tour-4"
                variant="outlined"
              >
                Edit Note
              </Button>
              <Typography 
                variant="body2" 
                sx={{ 
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                  lineHeight: 1.5,
                  wordBreak: 'break-word'
                }}
              >
                {notes}
              </Typography>
            </Box>
          )}
        </Box>

        <Collapse in={editColor}>
          <Paper 
            elevation={2} 
            sx={{ 
              p: { xs: 2, sm: 3 }, 
              mt: { xs: 2, sm: 3 },
              borderRadius: { xs: 1, sm: 2 }
            }}
          >
            <Typography 
              variant="h6" 
              sx={{ 
                mb: 2,
                fontSize: { xs: '1.1rem', sm: '1.25rem' }
              }}
            >
              Choose a color
            </Typography>
            <Box sx={{ 
              display: 'flex', 
              justifyContent: { xs: 'center', sm: 'flex-start' },
              overflowX: 'auto',
              pb: 1
            }}>
              <CirclePicker
                color={selectedColor}
                circleSpacing={isMobile ? 10 : 13.5}
                circleSize={isMobile ? 20 : 28}
                width={isMobile ? "280px" : "100%"}
                onChangeComplete={handleChangeComplete}
              />
            </Box>
          </Paper>
        </Collapse>

        <Box mt={{ xs: 3, sm: 4 }} id="tour-5">
          <Typography 
            variant="h6" 
            color="text.primary"
            sx={{ 
              mb: 2,
              fontSize: { xs: '1.1rem', sm: '1.25rem' },
              fontWeight: 600
            }}
          >
            E-mails subscribed to this Tier
          </Typography>
          <Paper 
            variant="outlined"
            sx={{ 
              borderRadius: { xs: 1, sm: 2 },
              overflow: 'hidden'
            }}
          >
            {emailList.length > 0 ? (
              <List disablePadding>
                {emailList.map((item) => (
                  <EmailList key={item.id} data={item} />
                ))}
              </List>
            ) : (
              <Box sx={{ 
                p: { xs: 3, sm: 4 }, 
                textAlign: "center",
                py: { xs: 4, sm: 6 }
              }}>
                <Typography 
                  color="text.secondary"
                  sx={{ fontSize: { xs: '0.9rem', sm: '1rem' } }}
                >
                  No emails subscribed to this tier yet.
                </Typography>
              </Box>
            )}
          </Paper>
        </Box>
      </Paper>
    </Container>
  );
}

import { useNavigate, useParams } from "react-router-dom";

function TierDetailsWrapper(props) {
  const navigate = useNavigate();
  const { id } = useParams();
  return <TierDetails {...props} match={{ params: { id } }} navigate={navigate} />;
}

export default TierDetailsWrapper;
